export function parseAlignProp(align) {
  switch (align) {
    case 'top':
    case 'left':
    default:
      return 'initial';
    case 'center':
      return 'center';
    case 'right':
    case 'bottom':
      return 'flex-end';
  }
}